import React from 'react';
import PropTypes from 'prop-types';

const ItemDescription = ({ item = {} }) => {
  let description = item.description;

  const is_experience = item['@type'] === 'Esperienza' || item.is_experience;
  if (is_experience && description?.length > 85) {
    description = description.substring(0, 85) + '...';
  }

  return (
    <>
      {item.description_card && (
        <div className="item-description description-card">
          {item.description_card}
        </div>
      )}
      {description && <div className="item-description">{description}</div>}
    </>
  );
};

ItemDescription.propTypes = {
  item: PropTypes.object,
};

export default ItemDescription;
